<template>
  <div class="chat__feed__item__interact">
    <div class="chat__feed__item__interact__like">
      <div class="chat__feed__reaction-trigger">
        <button type="button" @click="togglePostReaction">
          <div class="button__icon" :class="{ active: !!postReaction() }">
            <span v-if="postReaction() && postReaction().type !== 'like'"
              class="chat__feed__reaction-emoji">{{ postReaction().emoji }}</span>
            <svg v-else width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.1896 2.00301C11.9053 1.02086 10.0165 1.62526 9.94096 1.62526C9.78986 1.62526 9.71431 1.77636 9.71431 2.00301V6.00716C9.71431 7.36706 9.03436 8.50031 7.82556 9.40691C6.84341 10.0869 5.18131 10.0869 4.87911 10.0869H2.15931C1.70601 10.0869 1.40381 10.4646 1.40381 10.8424V20.7277C1.40381 21.181 1.78156 21.4832 2.15931 21.4832H16.0605C18.1759 21.4832 19.4603 20.4255 19.6869 18.4612L20.9713 12.2778C21.1224 11.1446 20.6691 9.93576 19.7625 9.33136C19.2336 8.95361 18.6292 8.72696 18.0248 8.72696H14.474V5.10056C14.474 3.58956 14.0207 2.60741 13.1896 2.00301Z"
                stroke="#8C95A3" stroke-width="1.5" stroke-miterlimit="10"></path>
            </svg>
          </div>
        </button>
        <div class="chat__feed__reaction-picker">
          <div class="chat__feed__reaction-picker__inner">
            <button v-for="r in reactions" :key="r.type" type="button" :title="r.label"
              @click="setPostReaction(r.type)">
              <svg v-if="r.type === 'like'" width="18" height="19" viewBox="0 0 22 23" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.1896 2.00301C11.9053 1.02086 10.0165 1.62526 9.94096 1.62526C9.78986 1.62526 9.71431 1.77636 9.71431 2.00301V6.00716C9.71431 7.36706 9.03436 8.50031 7.82556 9.40691C6.84341 10.0869 5.18131 10.0869 4.87911 10.0869H2.15931C1.70601 10.0869 1.40381 10.4646 1.40381 10.8424V20.7277C1.40381 21.181 1.78156 21.4832 2.15931 21.4832H16.0605C18.1759 21.4832 19.4603 20.4255 19.6869 18.4612L20.9713 12.2778C21.1224 11.1446 20.6691 9.93576 19.7625 9.33136C19.2336 8.95361 18.6292 8.72696 18.0248 8.72696H14.474V5.10056C14.474 3.58956 14.0207 2.60741 13.1896 2.00301Z"
                  fill="var(--color-icons, #2961D0)"></path>
              </svg>
              <template v-else>{{ r.emoji }}</template>
            </button>
          </div>
        </div>
      </div>
      <span class="chat__feed__reaction-count">
        {{ post.likes?.length || 0 }}
        <div v-if="post.likes && post.likes.length > 0" class="chat__feed__actions-menu chat__feed__likes-menu">
          <div class="chat__feed__likes-menu__item" v-for="like in post.likes" :key="like.id">
            <div class="chat__profile-img">
              <img :src="apiUrl + like.profileImageUrl" />
            </div>
            <span>{{ reactionEmoji(like.reactionType) }} {{ like.name }}</span>
          </div>
        </div>
      </span>
    </div>

    <button type="button" @click="showComments = !showComments">
      <div class="button__icon">
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 14H5.75V13.25H5V14ZM6.74741 18.0342L6.18685 17.5359L6.18685 17.5359L6.74741 18.0342ZM10.3333 14V13.25H9.99653L9.77278 13.5017L10.3333 14ZM1.75 4C1.75 2.75736 2.75736 1.75 4 1.75V0.25C1.92893 0.25 0.25 1.92893 0.25 4H1.75ZM1.75 11V4H0.25V11H1.75ZM4 13.25C2.75736 13.25 1.75 12.2426 1.75 11H0.25C0.25 13.0711 1.92893 14.75 4 14.75V13.25ZM5 13.25H4V14.75H5V13.25ZM5.75 17.3698V14H4.25V17.3698H5.75ZM6.18685 17.5359C6.03413 17.7077 5.75 17.5997 5.75 17.3698H4.25C4.25 18.979 6.2389 19.7351 7.30797 18.5324L6.18685 17.5359ZM9.77278 13.5017L6.18685 17.5359L7.30797 18.5324L10.8939 14.4983L9.77278 13.5017ZM17 13.25H10.3333V14.75H17V13.25ZM19.25 11C19.25 12.2426 18.2426 13.25 17 13.25V14.75C19.0711 14.75 20.75 13.0711 20.75 11H19.25ZM19.25 4V11H20.75V4H19.25ZM17 1.75C18.2426 1.75 19.25 2.75736 19.25 4H20.75C20.75 1.92893 19.0711 0.25 17 0.25V1.75ZM4 1.75H17V0.25H4V1.75Z"
            fill="#8C95A3"></path>
        </svg>
      </div>
      {{ post.comments?.length || 0 }}
    </button>
    <button v-if="isShareVisible" @click="copyToClipboard($event.target)" class="js-button-share" aria-label="Kopier link til udklipsholder">
      <div class="button__icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          width="20" height="20" viewBox="0 0 512 512" version="1.1">
          <title>Del</title>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="icon" fill="#8C95A3" transform="translate(42.666667, 42.666667)">
              <path
                d="M352,277.333333 C330.312533,277.333333 310.953173,286.729173 297.312427,301.494827 L148.109227,236.136747 C148.763093,232.164053 149.333333,228.157653 149.333333,224 C149.333333,216.23168 147.8112,208.889387 145.610667,201.8464 L297.605547,125.527467 C311.231787,140.096427 330.477867,149.333333 352,149.333333 C393.236907,149.333333 426.666667,115.903573 426.666667,74.6666667 C426.666667,33.42976 393.236907,3.55271368e-14 352,3.55271368e-14 C310.763093,3.55271368e-14 277.333333,33.42976 277.333333,74.6666667 C277.333333,79.0065067 277.899733,83.2004267 278.610773,87.3371733 L121.455787,166.246187 C108.619733,155.832107 92.4829867,149.333333 74.6666667,149.333333 C33.42976,149.333333 3.55271368e-14,182.763093 3.55271368e-14,224 C3.55271368e-14,265.236907 33.42976,298.666667 74.6666667,298.666667 C96.3541333,298.666667 115.713493,289.270827 129.35424,274.505173 L278.55744,339.863253 C277.903573,343.835947 277.333333,347.842347 277.333333,352 C277.333333,393.236907 310.763093,426.666667 352,426.666667 C393.236907,426.666667 426.666667,393.236907 426.666667,352 C426.666667,310.763093 393.236907,277.333333 352,277.333333 Z M352,42.6666667 C369.644587,42.6666667 384,57.02208 384,74.6666667 C384,92.3112533 369.644587,106.666667 352,106.666667 C334.355413,106.666667 320,92.3112533 320,74.6666667 C320,57.02208 334.355413,42.6666667 352,42.6666667 Z M74.6666667,256 C57.02208,256 42.6666667,241.644587 42.6666667,224 C42.6666667,206.355413 57.02208,192 74.6666667,192 C92.3112533,192 106.666667,206.355413 106.666667,224 C106.666667,241.644587 92.3112533,256 74.6666667,256 Z M352,384 C334.355413,384 320,369.644587 320,352 C320,334.355413 334.355413,320 352,320 C369.644587,320 384,334.355413 384,352 C384,369.644587 369.644587,384 352,384 Z"
                id="Shape"></path>
            </g>
          </g>
        </svg></div>Del
    </button>
  </div>
  <div class="chat__feed__item__comments" :class="{ collapsed: !showComments }">
    <div class="chat__feed__item__comments__comment" v-for="comment in sortedComments" :key="comment.id">
      <div class="chat__feed__profile">
        <div class="chat__profile-img">
          <img :src="apiUrl + comment.userImageUrl" />
        </div>
      </div>
      <div class="container">
        <div class="chat__feed__item__content">
          <p class="sender">
            <!-- TODO  PROFILE ULR Link to user profile -->
            <a :href="'/profil?initials=' + comment.userAlias">{{
              comment.userName
            }}</a>
          </p>
          <div class="rich-text" v-show="editCommentId !== comment.id">
            <p class="chat__feed__item__text"
              :class="{ 'chat__feed__item__text--collapsed': isLongComment(comment) && !isExpanded(comment) }"
              v-html="comment.comment"></p>
            <button v-if="isLongComment(comment)" type="button" class="chat__feed__item__read-more"
              @click="toggleExpanded(comment.id)">
              {{ isExpanded(comment) ? 'Vis mindre' : 'Læs mere' }}
            </button>
          </div>
          <div class="chat__feed__post" v-show="editCommentId === comment.id">
            <div class="chat__feed__post__form">
              <input class="comment-field" type="text" name="Message" v-model="editCommentText" />
              <div class="btn-container">
                <button class="btn btn__secondary editcomment-savepost" aria-label="Gem ændringer til kommentar"
                  @click="editComment(comment.id)">
                  Gem
                </button>
                <button class="btn btn__secondary editpost-undo" aria-label="Fortryd ændringer"
                  @click="(editCommentId = null), (editCommentText = '')">
                  Fortryd
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="label">
          <span>{{ formatRelativeTime(comment.date) }}</span>
          <div class="chat__feed__item__interact__like chat__feed__comment__like">
            <div class="chat__feed__reaction-trigger">
              <button type="button" @click="toggleCommentReaction(comment)">
                <div class="button__icon" :class="{ active: !!commentReaction(comment) }">
                  <span v-if="commentReaction(comment) && commentReaction(comment).type !== 'like'"
                    class="chat__feed__reaction-emoji">{{ commentReaction(comment).emoji }}</span>
                  <svg v-else width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.1896 2.00301C11.9053 1.02086 10.0165 1.62526 9.94096 1.62526C9.78986 1.62526 9.71431 1.77636 9.71431 2.00301V6.00716C9.71431 7.36706 9.03436 8.50031 7.82556 9.40691C6.84341 10.0869 5.18131 10.0869 4.87911 10.0869H2.15931C1.70601 10.0869 1.40381 10.4646 1.40381 10.8424V20.7277C1.40381 21.181 1.78156 21.4832 2.15931 21.4832H16.0605C18.1759 21.4832 19.4603 20.4255 19.6869 18.4612L20.9713 12.2778C21.1224 11.1446 20.6691 9.93576 19.7625 9.33136C19.2336 8.95361 18.6292 8.72696 18.0248 8.72696H14.474V5.10056C14.474 3.58956 14.0207 2.60741 13.1896 2.00301Z"
                      stroke="#8C95A3" stroke-width="1.5" stroke-miterlimit="10"></path>
                  </svg>
                </div>
              </button>
              <div class="chat__feed__reaction-picker">
                <div class="chat__feed__reaction-picker__inner">
                  <button v-for="r in reactions" :key="r.type" type="button" :title="r.label"
                    @click="setCommentReaction(comment, r.type)">
                    <svg v-if="r.type === 'like'" width="18" height="19" viewBox="0 0 22 23" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.1896 2.00301C11.9053 1.02086 10.0165 1.62526 9.94096 1.62526C9.78986 1.62526 9.71431 1.77636 9.71431 2.00301V6.00716C9.71431 7.36706 9.03436 8.50031 7.82556 9.40691C6.84341 10.0869 5.18131 10.0869 4.87911 10.0869H2.15931C1.70601 10.0869 1.40381 10.4646 1.40381 10.8424V20.7277C1.40381 21.181 1.78156 21.4832 2.15931 21.4832H16.0605C18.1759 21.4832 19.4603 20.4255 19.6869 18.4612L20.9713 12.2778C21.1224 11.1446 20.6691 9.93576 19.7625 9.33136C19.2336 8.95361 18.6292 8.72696 18.0248 8.72696H14.474V5.10056C14.474 3.58956 14.0207 2.60741 13.1896 2.00301Z"
                        fill="var(--color-icons, #2961D0)"></path>
                    </svg>
                    <template v-else>{{ r.emoji }}</template>
                  </button>
                </div>
              </div>
            </div>
            <span class="chat__feed__reaction-count">
              {{ comment.likes?.length || 0 }}
              <div v-if="comment.likes && comment.likes.length > 0" class="chat__feed__actions-menu chat__feed__likes-menu">
                <div class="chat__feed__likes-menu__item" v-for="like in comment.likes" :key="like.id">
                  <div class="chat__profile-img">
                    <img :src="apiUrl + like.profileImageUrl" />
                  </div>
                  <span>{{ reactionEmoji(like.reactionType) }} {{ like.name }}</span>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div v-if="comment.userAlias === currentUserAlias" class="chat__feed__actions">
        <button class="chat__feed__actions-btn icon-service-dot-menu"
          @click.stop="openCommentKebabId = openCommentKebabId === comment.id ? null : comment.id">
        </button>
        <div v-if="openCommentKebabId === comment.id" class="chat__feed__actions-menu">
          <button @click="
            (editCommentId = comment.id), (editCommentText = comment.comment);
            openCommentKebabId = null
            ">
            Rediger
          </button>
          <button @click="confirmDeleteId = comment.id; openCommentKebabId = null"
            class="chat__feed__actions-menu__delete">
            Slet
          </button>
        </div>
        <div v-if="confirmDeleteId === comment.id" class="chat__feed__actions-confirm">
          <span>Slet kommentaren?</span>
          <button class="btn btn--xs btn__secondary" @click="deleteComment(comment.id)">Ja, slet</button>
          <button class="btn btn--xs btn__secondary" @click="confirmDeleteId = null">Annuller</button>
        </div>
      </div>
    </div>
    <div class="chat__feed__post">
      <div class="chat__feed__post__form">
        <form autocomplete="off" class="comment-form" @submit.prevent="addComment">
          <input class="comment-field" type="text" name="Message" placeholder="Skriv kommentar" v-model="comment" />
          <button type="button" class="post-comment chat__send" aria-label="Post message" @click="addComment()">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="21"
              height="21" viewBox="0 0 350 350" xml:space="preserve">
              <g style="
                  stroke: none;
                  stroke-width: 1;
                  stroke-dasharray: none;
                  stroke-linecap: butt;
                  stroke-linejoin: miter;
                  stroke-miterlimit: 10;
                  fill: none;
                  fill-rule: nonzero;
                  opacity: 1;
                " transform="translate(-1.9444444444444287 -1.9444444444444287) scale(3.89 3.89)">
                <path
                  d="M 89.998 2.083 c 0.007 -0.167 -0.002 -0.333 -0.036 -0.497 c -0.005 -0.022 -0.013 -0.042 -0.019 -0.063 c -0.035 -0.143 -0.087 -0.282 -0.154 -0.416 c -0.019 -0.038 -0.038 -0.075 -0.059 -0.112 c -0.085 -0.147 -0.184 -0.289 -0.31 -0.415 c -0.125 -0.125 -0.266 -0.223 -0.412 -0.308 c -0.04 -0.023 -0.079 -0.043 -0.121 -0.063 c -0.13 -0.064 -0.264 -0.115 -0.402 -0.149 c -0.026 -0.006 -0.049 -0.017 -0.075 -0.022 c -0.162 -0.033 -0.326 -0.042 -0.491 -0.035 c -0.043 0.002 -0.084 0.008 -0.127 0.012 c -0.147 0.016 -0.292 0.046 -0.433 0.095 c -0.019 0.006 -0.038 0.005 -0.057 0.012 L 1.298 32.396 c -0.75 0.281 -1.259 0.982 -1.295 1.782 c -0.036 0.8 0.408 1.544 1.129 1.892 l 35.612 17.186 L 53.93 88.869 C 54.264 89.562 54.967 90 55.731 90 c 0.03 0 0.061 -0.001 0.091 -0.002 c 0.8 -0.036 1.5 -0.546 1.781 -1.295 L 89.859 2.748 c 0 -0.001 0.001 -0.002 0.001 -0.004 l 0.018 -0.048 c 0.006 -0.016 0.005 -0.032 0.011 -0.048 c 0.05 -0.145 0.081 -0.294 0.097 -0.445 C 89.99 2.163 89.996 2.124 89.998 2.083 z M 80.059 7.113 L 37.831 49.34 L 7.08 34.499 L 80.059 7.113 z M 55.501 82.92 L 40.66 52.168 L 82.888 9.94 L 55.501 82.92 z"
                  style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 10;
                    fill: rgb(0, 0, 0);
                    fill-rule: nonzero;
                    opacity: 1;
                  " transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path>
              </g>
            </svg>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/da";
dayjs.extend(relativeTime);
dayjs.locale("da");

export default {
  name: "PostComments",
  props: {
    post: {
      type: Object,
      required: true,
    },
    currentUserAlias: {
      type: String,
      required: true,
    },
    shareButtonPath: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      localPostData: { post: {} },
      apiUrl: process.env.VUE_APP_API_URL,
      rootId: 0,
      comment: "",
      confirmDeleteId: null,
      editCommentId: null,
      editCommentText: null,
      openCommentKebabId: null,
      showComments: false,
      postPagePath: "",
      expandedCommentIds: [],
      longCommentCharLimit: 220,
      commentLineClamp: 3,
      reactions: [
        { type: 'like', emoji: '👍', label: 'Synes godt om' },
        { type: 'love', emoji: '❤️', label: 'Elsker' },
        { type: 'clap', emoji: '👏', label: 'Klapper' },
        { type: 'laugh', emoji: '😂', label: 'Sjovt' },
      ],
    };
  },
  watch: {
    post: {
      handler(newpost) {
        this.localPostData = newpost; // Brug array direkte
        console.log("Post opdateret:", this.localPostData);
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    sortedComments() {
      return [...(this.localPostData?.comments || [])].sort(
        (b, a) => new Date(a.date) - new Date(b.date)
      );
    },
    isShareVisible() {
      const stringPath = this.postPagePath;
      return typeof stringPath === 'string' && stringPath.trim() !== '' && stringPath !== undefined;
    },
  },
  emits: ["updatePost"],
  methods: {
    async addComment() {
      try {
        if (this.comment.length <= 1) {
          return;
        }
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/api/MessageWall/AddNewCommentToPost`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              relatedPostId: this.post.id,
              userAlias: this.currentUserAlias,
              message: this.comment,
              // Kommentarer på en nyhed gemmes som "news", så de ikke blandes med et opslag med samme id.
              type: this.post.postType === "news" ? "news" : "comment",
            }),
          }
        );
        const comments = await response.json();
        console.log("Ny kommentar oprettet:", comments);
        this.localPostData.comments = comments;
        if (!response.ok) {
          throw new Error("Fejl under oprettelse af kommentar");
        }
        this.comment = "";
      } catch (error) {
        console.error("Fejl under opdatering af comments:", error);
      }
    },
    async editComment(commentId) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/api/MessageWall/UpdatePost`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              postId: commentId,
              post: this.editCommentText,
              userAlias: this.currentUserAlias
            })
          }
        );

        const result = await response.json();
        if (!response.ok) {
          throw new Error(result?.message || "Fejl under opdatering af kommentar");
        }

        // Opdater lokalt kommentaren
        this.localPostData.comments.forEach((comment) => {
          if (comment.id === commentId) {
            comment.comment = this.editCommentText;
          }
        });

        this.editCommentId = null;
        this.editCommentText = null;

      } catch (error) {
        console.error("Fejl under opdatering af comments:", error);
      }
    }
    ,
    async deleteComment(id) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/api/MessageWall/DeletePost?postId=${id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
        if (!response.ok) {
          throw new Error("Fejl under sletning af kommentar");
        }
        const successfull = await response.json();
        if (successfull) {
          this.confirmDeleteId = null;
          this.localPostData.comments = this.localPostData.comments.filter(
            (comment) => comment.id !== id
          );
          return;
        }
      } catch (error) {
        console.error("Fejl under sletning af kommentar:", error);
      }
    },
    formatRelativeTime(date) {
      return dayjs(date).fromNow();
    },
    stripHtml(html) {
      if (!html) return '';
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    },
    lineCount(html) {
      if (!html) return 0;
      const normalized = String(html)
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/(p|div|li|h[1-6]|blockquote|pre)>/gi, '\n');
      const tmp = document.createElement('div');
      tmp.innerHTML = normalized;
      const text = tmp.textContent || tmp.innerText || '';
      return text.replace(/\n+$/, '').split('\n').length;
    },
    isLongComment(comment) {
      if (this.stripHtml(comment.comment).length > this.longCommentCharLimit) return true;
      return this.lineCount(comment.comment) > this.commentLineClamp;
    },
    isExpanded(comment) {
      return this.expandedCommentIds.includes(comment.id);
    },
    toggleExpanded(commentId) {
      this.expandedCommentIds = this.expandedCommentIds.includes(commentId)
        ? this.expandedCommentIds.filter(id => id !== commentId)
        : [...this.expandedCommentIds, commentId];
    },
    reactionEmoji(type) {
      return this.reactions.find(r => r.type === type)?.emoji || '👍';
    },
    postReaction() {
      const mine = this.localPostData.likes?.find(l => l.userAlias === this.currentUserAlias);
      if (!mine) return null;
      return this.reactions.find(r => r.type === mine.reactionType) || this.reactions[0];
    },
    togglePostReaction() {
      const current = this.postReaction();
      this.setPostReaction(current ? current.type : 'like');
    },
    async copyToClipboard(shareButton) {
      try {
        console.log("post", this.post);
        await navigator.clipboard.writeText(window.location.origin + this.postPagePath + "?id=" + this.post.id + "&type=" + this.post.postType);

        const existingMsg = shareButton.querySelector('.chat__feed__item__interact--share-msg');
        if (existingMsg) {
          existingMsg.remove();
        }
        const shareMsg = document.createElement('span');
        shareMsg.classList.add('chat__feed__item__interact--share-msg');
        shareMsg.innerText = 'Link kopieret til udklipsholder';

        shareButton.appendChild(shareMsg);
        setTimeout(() => {
          shareMsg.remove();
        }, 700);
      } catch (err) {
        console.error("Fejl ved kopiering af link: ", err);
      }
    },
    async setPostReaction(reactionType) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/api/MessageWall/AddNewLikes`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              relatedPostId: this.post.id,
              userAlias: this.currentUserAlias,
              type: this.post.postType,
              reactionType,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Fejl under oprettelse af reaktion");
        }

        const likes = await response.json();
        this.localPostData.likes = likes;
      } catch (error) {
        console.error("Fejl under opdatering af reaktion:", error);
      }
    },
    commentReaction(comment) {
      const mine = comment.likes?.find(l => l.userAlias === this.currentUserAlias);
      if (!mine) return null;
      return this.reactions.find(r => r.type === mine.reactionType) || this.reactions[0];
    },
    toggleCommentReaction(comment) {
      const current = this.commentReaction(comment);
      this.setCommentReaction(comment, current ? current.type : 'like');
    },
    async setCommentReaction(comment, reactionType) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/api/MessageWall/AddNewLikes`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              relatedPostId: comment.id,
              userAlias: this.currentUserAlias,
              type: "comment",
              reactionType,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Fejl under oprettelse af reaktion");
        }

        const likes = await response.json();
        const target = this.localPostData.comments.find(c => c.id === comment.id);
        if (target) {
          target.likes = likes;
        }
      } catch (error) {
        console.error("Fejl under opdatering af kommentar-reaktion:", error);
      }
    },
    handleOutsideClick() {
      this.openCommentKebabId = null;
    },
  },
  mounted() {
    const chatwallWrapper = document.querySelector(".chat-wrapper");
    this.postPagePath = chatwallWrapper.dataset.postpagepath || "";
    this.userAlias = chatwallWrapper.dataset.useralias;
    console.log("shareButtonPath", this.shareButtonPath);
    this.rootId = chatwallWrapper.dataset.rootid;
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
};
</script>

<style>
.chat__feed__item__interact__like.chat__feed__comment__like {
  display: inline-flex;
  margin-right: 0;
  margin-left: 10px;
  vertical-align: middle;
}

.chat__feed__comment__like button {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  font: inherit;
}

.chat__feed__comment__like .button__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
}

.chat__feed__comment__like .button__icon.active svg path {
  fill: var(--color-icons, #2961D0);
  stroke: transparent;
}

.chat__feed__item__text--collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.chat__feed__item__read-more {
  display: inline-block;
  padding: 0;
  margin-top: 2px;
  background: none;
  border: none;
  color: var(--color-link, #1877f2);
  font-weight: 600;
  cursor: pointer;
}

.chat__feed__item__read-more:hover {
  text-decoration: underline;
}

.chat__feed__item__interact__like {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 50px;
}

.chat__feed__item__interact__like button {
  margin-right: 0 !important;
}

@media (max-width: 767.98px) {
  .chat__feed__item__interact__like {
    margin-right: 25px;
  }
}

.chat__feed__item__interact__like .chat__feed__likes-menu {
  display: none;
  max-height: 220px;
  overflow-y: auto;
  flex-direction: column;
}

.chat__feed__reaction-count:hover .chat__feed__likes-menu {
  display: flex;
}

.chat__feed__likes-menu__item {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  white-space: nowrap;
}

.chat__feed__likes-menu__item .chat__profile-img {
  display: flex;
  height: 20px;
  width: 20px;
  margin-right: 8px;
}

.chat__feed__likes-menu__item .chat__profile-img img {
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

.chat__feed__reaction-trigger {
  position: relative;
  display: flex;
  align-items: center;
}

.chat__feed__reaction-count {
  position: relative;
  margin-left: 6px;
}

.chat__feed__reaction-emoji {
  font-size: 1.1em;
  line-height: 1;
}

.chat__feed__reaction-picker {
  display: none;
  position: absolute;
  /* Flush against the button (no gap) — any gap here is dead space the
     mouse has to cross, which drops :hover and makes the picker vanish
     before it can be reached. */
  bottom: 100%;
  left: 0;
  padding-bottom: 8px;
  z-index: 10;
}

.chat__feed__reaction-picker__inner {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  background: #fff;
  border: 1px solid var(--color-grey-medium, #e0e0e0);
  border-radius: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  white-space: nowrap;
}

.chat__feed__reaction-trigger:hover .chat__feed__reaction-picker {
  display: flex;
}

.chat__feed__reaction-picker button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 2px;
  margin: 0;
  font-size: 1.4em;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.1s ease;
}

.chat__feed__reaction-picker button:hover {
  transform: scale(1.25);
}
</style>
